import {gql} from "@apollo/client";

export const GET_FILES = gql`
	query Files($id: Int!, $entityType: EntityType!)
	{
	   files(id :$id, entityType: $entityType)
	}
`;
